export default ($axios) => ({
    $axios,

    async login(form) {
        return await $axios.post('/signin', form)
    },
})
